export default {
  version: 0.1,
  timeout: 60000,
  apiPrefix: '',
  requestRetry: 4,
  requestRetryDelay: 800,
  tokenKey: 'ACCESS_TOKEN',
  userInfoKey: 'USER_INFO',
  permissionsKey: 'PERMISSION_ARRAY',
  pageSizesArr: [14, 32, 64]
};
